import React from "react";
import { Button, CircularProgress } from "@material-ui/core";
import "./CommonButtons.css";

const LoadingButton = ({ loading, children, disabled, isDelete, ...props }) => {
  const className = isDelete
    ? `${props.className || ''} delete-button`.trim()
    : props.className;

  return (
    <Button
      {...props}
      className={className}
      disabled={disabled || loading}
      startIcon={loading ? <CircularProgress size={16} color="inherit" /> : props.startIcon}
    >
      {children}
    </Button>
  );
};

export default LoadingButton;
